import React from "react";
import Header from "./Header";
import BottomNav from "./BottomNav";
import { Outlet, useLocation } from "react-router-dom";

export default function Layout({ children, onLogout }) {
  const location = useLocation();
  const hideNav = location.pathname === "/login";

  return (
    <div className="app-layout">
      {/* Header at the top */}
      {!hideNav && <Header onLogout={onLogout} />}

      {/* Main content area */}
      <div className="page-content">{children || <Outlet />}</div>

      {/* BottomNav fixed at bottom */}
      {!hideNav && <BottomNav />}
    </div>
  );
}
